import { useEffect, useState } from "react";
import { Menu, Phone, X } from "lucide-react";

const LINKS = [
  { label: "Who Qualifies", href: "#professions", testId: "nav-link-who-qualifies" },
  { label: "Savings", href: "#savings", testId: "nav-link-savings" },
  { label: "How It Works", href: "#how-it-works", testId: "nav-link-how-it-works" },
  { label: "Contact", href: "#contact", testId: "nav-link-contact" },
];

export const scrollToSection = (href) => {
  if (window.__lenis) window.__lenis.scrollTo(href, { offset: -70, duration: 1.4 });
  else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = ({ onQualify }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollToSection(href);
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-40 transition-[background-color,box-shadow] duration-500 ${
        scrolled || open ? "bg-[#060D1A]/95 shadow-[0_10px_40px_rgba(6,13,26,0.45)] backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <a href="#top" data-testid="nav-logo" onClick={(e) => go(e, "#top")} className="flex items-center gap-3">
          <img src="/assets/prmg-logo.png" alt="PRMG - Paramount Residential Mortgage Group, Inc." className="h-9 w-auto sm:h-10" />
          <span className="hidden h-7 w-px bg-[#F59E0B]/60 sm:block" />
          <span className="hidden font-mono text-xs font-bold uppercase tracking-[0.22em] text-[#FEF3C7] sm:block lg:hidden">
            Georgia Local Heroes
          </span>
        </a>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              onClick={(e) => go(e, l.href)}
              className="font-mono text-sm font-medium uppercase tracking-[0.15em] text-[#FAF8F5]/75 transition-colors hover:text-[#F59E0B]"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <a
            href="tel:8312775422"
            data-testid="nav-call-btn"
            className="hidden items-center gap-2 font-body text-sm font-semibold tracking-wide text-[#FAF8F5]/85 transition-colors hover:text-[#F59E0B] md:flex"
          >
            <Phone size={15} /> 831-277-5422
          </a>
          <button
            data-testid="nav-qualify-btn"
            onClick={onQualify}
            className="whitespace-nowrap rounded-full bg-[#DC2626] px-4 py-2.5 font-mono text-xs font-bold uppercase tracking-[0.15em] text-white transition-[transform,background-color,box-shadow] duration-300 hover:-translate-y-0.5 hover:bg-[#B91C1C] hover:shadow-[0_8px_24px_rgba(220,38,38,0.4)] sm:px-6 sm:py-3 sm:text-sm"
          >
            Submit Your Interest
          </button>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen(!open)}
            className="text-[#FAF8F5] lg:hidden"
            aria-label="Toggle navigation menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-white/10 bg-[#060D1A] px-5 pb-6 pt-2 lg:hidden">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`${l.testId}-mobile`}
              onClick={(e) => go(e, l.href)}
              className="block border-b border-white/5 py-4 font-mono text-sm uppercase tracking-[0.2em] text-[#FAF8F5]/85"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
